import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useSite, resolveImg } from "@/lib/content";

/**
 * /menu route — opens the current PDF in a new tab, then shows a small
 * confirmation page with a manual "open" button in case popups were blocked.
 */
export default function MenuRedirect() {
  const { content } = useSite();
  const menuUrl = resolveImg(content.menu_pdf_url || "/menu-la-matze.pdf");
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    const w = window.open(menuUrl, "_blank", "noopener,noreferrer");
    setOpened(Boolean(w));
  }, [menuUrl]);

  return (
    <div
      data-testid="page-menu-redirect"
      className="min-h-[70vh] flex items-center justify-center px-6 text-center pt-24 sm:pt-28"
    >
      <div className="max-w-md">
        <div className="lm-eyebrow justify-center">Menu</div>
        <p className="font-serif-display text-2xl sm:text-3xl mt-6 text-[#1A1A18]">
          {opened
            ? "Votre menu vient de s'ouvrir dans un nouvel onglet."
            : "Ouverture du menu…"}
        </p>
        <p className="mt-4 text-[#5C544F] text-sm leading-relaxed">
          Si rien ne s&rsquo;affiche, ouvrez-le manuellement ci-dessous.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={menuUrl}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="menu-open-btn"
            className="lm-btn-primary"
          >
            Ouvrir le menu <ExternalLink size={14} />
          </a>
          <Link to="/" className="lm-btn-outline">
            Retour à l&rsquo;accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
